import { EDIT_TEMPLATE_URL, JOIN_WAIT_LIST_URL } from '../config';
import { useInitialState } from '../contexts/InitialStateContext';

export const useEditUrl = (data: { metaSiteId: string }) => {
  const { metaSiteId } = data;
  const { userData } = useInitialState();
  const isStudioUser = userData.isLoggedIn && userData.profile.isStudioAccount;

  const editorUrl = new URL(EDIT_TEMPLATE_URL);
  editorUrl.searchParams.append('originTemplateId', metaSiteId);

  return isStudioUser ? editorUrl.href : JOIN_WAIT_LIST_URL;
};
